import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/currency/mh_w_logo.png'
import _imports_1 from '@/assets/currency/funnel.png'


const _withScopeId = n => (_pushScopeId("data-v-29d0a525"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dvBJ" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"dvTop\" data-v-29d0a525><div class=\"dvTopLeft\" data-v-29d0a525><div class=\"dvTopLeftLogo\" data-v-29d0a525><img src=\"" + _imports_0 + "\" alt=\"机灵树\" data-v-29d0a525></div><div class=\"dvTopLeftTitle\" data-v-29d0a525>· 艺术素质测评系统</div></div></div>", 1)
const _hoisted_3 = { class: "dvMid" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dvMidFunnel mt10" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dvMidTitle" }, "请等待测评开始", -1))
const _hoisted_6 = { class: "dvMidTitle dvMidCountDown mt2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "倒计时：", -1))
const _hoisted_8 = { class: "dvMidCountDown" }
const _hoisted_9 = { class: "countdown-item" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_11 = { class: "countdown-item" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_13 = { class: "countdown-item" }
const _hoisted_14 = { class: "dvBottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_countdown = _resolveComponent("countdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_countdown, {
            time: _ctx.time,
            format: "HH:mm:ss",
            onFinish: _ctx.handleFinish
          }, {
            default: _withCtx(({ resolved }) => [
              _createElementVNode("span", _hoisted_9, _toDisplayString(resolved.HH), 1),
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, _toDisplayString(resolved.mm), 1),
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString(resolved.ss), 1)
            ]),
            _: 1
          }, 8, ["time", "onFinish"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        class: "mb3 mr2 btnGoBack",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, "返 回")
    ])
  ]))
}